import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import { orderlistsReducer, orderlistSummaryReducer } from './orderlist/reducers';

import ageCategoryReducer from './ageCategory/reducers';
import breadcrumbReducer from './breadcrumbs/reducers';
import { copiesListReducers } from './copiesList/reducers';
import { groupingReducer } from './grouping/reducers';
import loanFormatReducer from './loanFormat/reducers';
import { notificationReducer } from './notifications/reducers';
import libxReducer from './libx/reducers';
import { collectionReducer } from './collection/reducers';
import { headerReducer } from './header/reducers';
import { addToCartOrListReducers } from './addToCartOrList/reducers';
import { authenticationReducer } from './authentication/reducers';
import { bundleReducer } from './bundle/reducers';
import { displayTypeReducer } from './displayType/reducers';
import { foreignLanguageReducer } from './foreignLanguage/reducers';
import { productSelectionReducer } from './productSelection/reducers';
import { reserveReducer } from './reserve/reducers';
import { searchReducer } from './search/reducers';
import { History, LocationState } from 'history';
import { AppAction } from './index';
import { uploadReducer } from './upload/reducers';
import productTypeReducer from './productType/reducers';
import listLoadingReducer from './listLoading/reducers';

const createAppReducer = (history: History<LocationState>) =>
    combineReducers({
        addToCartOrList: addToCartOrListReducers,
        ageCategory: ageCategoryReducer,
        authentication: authenticationReducer,
        breadcrumbs: breadcrumbReducer,
        bundle: bundleReducer,
        collection: collectionReducer,
        configs: (configs = {}) => configs,
        copiesList: copiesListReducers,
        displayType: displayTypeReducer,
        foreignLanguage: foreignLanguageReducer,
        grouping: groupingReducer,
        header: headerReducer,
        libx: libxReducer,
        listLoading: listLoadingReducer,
        loanFormat: loanFormatReducer,
        productType: productTypeReducer,
        notifications: notificationReducer,
        // FIXME the reducer and state is called orderlist, the actions are called selectionlist. This should be aligned
        orderlist: orderlistSummaryReducer,
        // FIXME the reducer and state is called orderlists, the actions are called selectionlists. This should be aligned
        orderlists: orderlistsReducer,
        productSelection: productSelectionReducer,
        reserve: reserveReducer,
        router: connectRouter(history),
        search: searchReducer,
        upload: uploadReducer
    });

export const createRootReducer = (history: History<LocationState>) => {
    const appReducer = createAppReducer(history);

    return (state, action: AppAction) => {
        if (action.type === 'SOFT_RESET') {
            const { router, authentication, orderlist, header } = state;
            state = { router, authentication, orderlist, header };
        }
        return appReducer(state, action);
    };
};
